<template>
  <select
    :name="name"
    :id="id ? id : name"
    v-model="modelValue"
    :required="required"
    :class="{
      'appearance-none': options.length === 1 || disabled || schema.readonly,
      'bg-yapgray-100 text-yapgray-600 dark:bg-yapdarkgray-900 dark:text-yapgray-200':
        disabled || readonly || schema.readonly
    }"
    :disabled="options.length === 1 || disabled || readonly || schema.readonly"
    v-bind="$attrs"
    @blur="$emit('blur')"
  >
    <option value="" disabled v-if="!props.schema.default">{{ t('dict.validation.pleaseSelect') }}</option>
    <option v-for="option in options" :key="option.value" :value="option.value">
      {{ option.label ?? option.value }}
    </option>
  </select>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { useI18n } from '@/plugins/i18n';
import { SchemaItem } from '@/components/form/types/schemaItem';

const modelValue = defineModel();

const emit = defineEmits(['update:modelValue', 'blur']);

const props = defineProps<{
  required?: boolean;
  schema: SchemaItem;
  disabled?: boolean;
  readonly?: boolean;
  name: string;
  id?: string;
}>();

const { t } = useI18n();

const options = computed(() => {
  const keys = props.schema.enum || props.schema.items?.enum;
  const values =
    props.schema['x-enumLabels'] ||
    (props.schema.items && props.schema.items['x-enumLabels']) ||
    props.schema['x-enumObjects']?.map((item) => item.title) ||
    props.schema.enum;

  if (keys && values) {
    const optionTypes: Array<{ value: string; label: string; default: boolean }> = [];
    keys.forEach((item: string, i: number) => {
      optionTypes.push({ value: item, label: values[i], default: item === props.schema.default });
    });
    return optionTypes;
  }
  return [];
});
</script>
